import { render, staticRenderFns } from "./ProposalsNav.vue?vue&type=template&id=1163c1ca&"
import script from "./ProposalsNav.vue?vue&type=script&lang=js&"
export * from "./ProposalsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports